import { endpoints, getIDFromUrl, ID } from '@rossum/api-client';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../../lib/apiClient';
import { useQueue } from './useQueue';

export const QUERY_KEY_WORKSPACE = 'workspace';

type UseQueueWithWorkspaceProps = {
  queueId: ID;
};
export const useQueueWithWorkspace = ({
  queueId,
}: UseQueueWithWorkspaceProps) => {
  const { data: queue, isLoading: queueIsLoading } = useQueue(queueId);

  const workspaceId = queue?.workspace
    ? getIDFromUrl(queue.workspace)
    : undefined;

  const { data: workspace, isLoading: workspaceIsLoading } = useQuery({
    queryKey: [QUERY_KEY_WORKSPACE, workspaceId] as const,
    queryFn: () => api.request(endpoints.workspaces.get(workspaceId ?? 0)),
    enabled: !!workspaceId,
  });

  return {
    queue,
    queueIsLoading,
    workspace,
    workspaceIsLoading,
  };
};
